import { RadioTextFilterOperation } from '@hotjar/global-filters';
import type { PageURLFilterValue } from '@hotjar/global-filters';
import type { PageFilterDto } from '../filters/FiltersMappings';
import { IncomingFeedbackDtoFilters } from '../filters/FiltersMappings';

export function pageURLFilterConverter(filterValue: PageURLFilterValue): PageFilterDto | undefined {
  if (!filterValue) return undefined;
  return {
    type: IncomingFeedbackDtoFilters.PAGE,
    operation:
      filterValue.operation === RadioTextFilterOperation.IS ? 'EQUALS' : filterValue.operation,
    value: filterValue.value,
  };
}
